/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import React from 'react';

import withCondition from '@commons/withCondition';

import commonStyles from '@css/outline.scss';

import { isWCAG21_4_Enabled_FF } from '@services/featureFlags';

import styles from './cell.scss';

/* eslint-disable react/forbid-component-props */

export function mainContainerStyles({ containerStyles, hasBorderStyle, hasHoverStyle }) {
  return classNames(styles.cell, containerStyles, {
    [commonStyles.hasBorder]: hasBorderStyle,
    [commonStyles.hasHover]: hasHoverStyle
  });
}

interface CellProps {
  ariaHidden?: boolean;
  ariaLabelledBy?: string;
  ariaRole?: string;
  children?: React.ReactNode;
  containerElement?: string;
  containerStyles?: string;
  hasBorderStyle?: boolean;
  hasHoverStyle?: boolean;
}

export default function Cell({
  ariaHidden,
  ariaLabelledBy,
  ariaRole,
  children,
  containerElement = 'div',
  containerStyles,
  hasBorderStyle,
  hasHoverStyle,
  optionsSize
}: CellProps) {
  const cellContainerStyles = mainContainerStyles({
    containerStyles,
    hasBorderStyle,
    hasHoverStyle
  });
  const Container = containerElement;

  if (optionsSize && isWCAG21_4_Enabled_FF()) {
    return (
      <li
        aria-hidden={ariaHidden}
        aria-labelledby={ariaLabelledBy}
        className={cellContainerStyles}
        role={ariaRole}>
        {children}
      </li>
    );
  }

  return (
    <Container
      aria-hidden={ariaHidden}
      aria-labelledby={ariaLabelledBy}
      className={cellContainerStyles}
      role={ariaRole}>
      {children}
    </Container>
  );
}

export const ConditionedCell = withCondition(Cell);
